<template>
  <div class="helpcenter-box">
    <!-- <FloorRolling></FloorRolling> -->
    <!-- <Header flag=true></Header> -->
    <!-- edf2f5 -->
    <!-- <div class="menubox bgff">
      <Menu></Menu>
    </div> -->
    <div class="Engineering_crumbs ">
      <!-- <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item >当前位置 : 帮助中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{crumbs}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div> -->
    </div>
    <div class="tc-20"></div>
    <div class="helpcenter-body">
      <div class="helpcenter-left bgff">
        <div class="tc-20"></div>
        <div class="biaoti">
          <div class="bg02"></div>
          <div class="text_center font22 color02">帮助中心</div>
          <div class="bg02"></div>
        </div>
        <div class="tc-50"></div>
        <el-row class="tac">
          <el-col :span="24">
            <el-menu
              :default-active="active"
              class="el-menu-vertical-demo"
              @select="handleSelect"
              :unique-opened="uniqueopened"
            >
              <el-submenu
                v-for="(item, index) in menulist"
                :key="index"
                :index="item.no"
              >
                <template slot="title">
                  <!--<i :class="['icon', 'iconfont', 'icon-' + item.icon]"></i>-->
                  <img v-if="item.icon != ''" :src="item.icon" />
                  <span>{{ item.name }}</span>
                </template>
                <div v-for="(items, indexs) in item.contentList" :key="indexs">
                  <el-menu-item :index="items.id + ''">
                    {{ items.title }}
                  </el-menu-item>
                </div>
              </el-submenu>
            </el-menu>
          </el-col>
        </el-row>
        <div class="tc-100"></div>
      </div>
      <div class="helpcenter-right">
        <div class="helpcenter-right-body">
          <router-view :content="content"> </router-view>
        </div>
      </div>
    </div>
    <div class="tc-40 bgcolor"></div>
  </div>
</template>

<script>
import apiHelp from "@/api/apiHelp"

export default {
  name: "Helpcenter",
  data() {
    return {
      menulist: [],
      uniqueopened: true,
      crumbs: "",
      content: {},
      imgUrl: "https://shigongbang.oss-cn-hangzhou.aliyuncs.com/",
      active: "", // 默认一级展开菜单
      openeds: "" // 二级展开菜单
    }
  },
  components: {},
  watch: {
    "$route.query.id"() {
      let firstId = this.$route.query.id
      let ids = [0, firstId]
      this.handleSelect(firstId, ids)
      this.active = String(firstId)
    }
  },
  // 监听
  mounted() {},
  // 方法
  methods: {
    ishow() {
      this.isshow = !this.isshow
    },
    // 选择子菜单，获取内容
    handleSelect(key, keyPath) {
      //
      //

      this.getChildrenData(keyPath[1])

      this.$router.push({
        path: "/content",
        query: {
          id: keyPath[1]
        }
      })
    },
    // 获取一、二级菜单栏
    async getData() {
      let { data } = await apiHelp.getContentList()
      this.menulist = data
      //
      // 根据地址传输过来的内容id进行查询
      let firstId = this.$route.query.id
      if (firstId === undefined) {
        // 如果没有id则默认取第一个
        firstId = this.menulist[0].contentList[0].id
      }
      let ids = [0, firstId]
      this.handleSelect(firstId, ids)
      this.active = String(firstId)
    },
    // 获取子级菜单栏内容
    async getChildrenData(key) {
      this.content = {}
      let res = await apiHelp.getContentDetails(key)
      this.content = res.data
    }
  },
  created() {
    // default-active	当前激活菜单的 index
    // default-openeds 当前打开的sub-menu的 key 数组
    //
    this.getData()
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "~@/styles/variable.scss";
.helpcenter-box {
  .text_center {
    text-align: center;
  }
  .helpcenter-body {
    width: 1200px;
    margin: 0 auto;
  }
  .helpcenter-right {
    // padding: 0 35px;
    width: 975px;
    display: inline-block;
    vertical-align: top;
    // .helpcenter-right-body{
    // padding: 0 35px;
    // }
    p {
      // text-indent: 2em;
      // width: 910px;
      // margin: 0 0 0 35px;
      line-height: 32px;
      img {
        max-width: 100%;
      }
    }
    h3 {
      // width: 945px;
      // margin: 0 0 0 35px;
      line-height: 32px;
    }
  }

  .helpcenter-left {
    width: 200px;
    /* height: 685px; */
    display: inline-block;
    vertical-align: top;
    margin: 0 20px 0 0;
    li {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .biaoti {
      width: 100%;
      height: 22px;
      position: relative;
      > div {
        &:nth-child(1) {
          width: 42px;
          height: 1px;
          position: absolute;
          left: 0px;
          top: 11px;
        }
        &:nth-child(2) {
          width: 116px;
          height: 22px;
          line-height: 22px;
          position: absolute;
          left: 42px;
        }
        &:nth-child(3) {
          width: 42px;
          height: 1px;
          position: absolute;
          right: 0px;
          top: 11px;
        }
      }
    }
  }
}
</style>
<style lang="scss" rel="stylesheet/scss">
.helpcenter-box {
  .helpcenter-left {
    li {
      .el-menu-item {
        text-indent: 1em;
      }
      img {
        width: 16px;
      }
    }
  }
}
</style>
